import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function SeriesList({ selectedShow, setSelectedShow, selectedSeriesList, 
    setSelectedSeriesList, activeHeader, setActiveHeader }) {
    const navigate = useNavigate();

    const [groupByNetwork, setGroupByNetwork] = useState(false);
    
    const groupedByNetwork = selectedSeriesList?.reduce((acc, s) => {
        const key = s.network || "Unknown";
        if (!acc[key]) acc[key] = [];
        acc[key].push(s);
        return acc;
    }, {});

    return (
        <div className="seriesList">
            <div className="seriesListHeaderRow">
                <h2 className="seriesListHeader">{activeHeader}</h2>
                <label className="networkToggle">
                   <span>Group by Network</span> 
                   <input
                        type="checkbox"
                        className="toggle-checkbox"
                        checked={groupByNetwork}
                        onChange={() => setGroupByNetwork(!groupByNetwork)}
                    />   
                </label>
            </div>
    
            {!groupByNetwork &&
                selectedSeriesList.map((s) => (
                <div
                    className="watching-item"
                    key={s._id}
                    onClick={() => {
                    navigate("/series", {  state: {
                            selectedShow: s,
                            selectedSeriesList: null,
                            activeHeader: null
                        } });
                    }}
                >
                    {s.title}
                </div>
                ))}

            {groupByNetwork &&
                Object.entries(groupedByNetwork || {}).map(([network, shows]) => (
                <div key={network}>
                    <p className="networkHeader">{network}: </p>

                    {shows.map((s) => (
                    <div
                        className="watching-item"
                        key={s._id}
                        onClick={() => {
                        navigate("/series", {  state: {
                                selectedShow: s,
                                selectedSeriesList: null,
                                activeHeader: null
                            } });
                        }}
                    >
                        <p className="seriesListItem">{s.title}</p>
                    </div>
                    ))}
                </div>
                ))}
        </div>
    )
}